module.exports = __webpack_public_path__ + "assets/img/help_image02-1.63b1c2b4.png";